import {
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    Theme
} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import useRouter from 'use-react-router';
import {TableEditBar} from '../../../components/TableEditBar';
import {PaginatiorInfo} from '../../../graphql/common.datatypes';
import {RoomParty} from '../../../graphql/groups.datatypes';
import {formatDate} from '../../../utils/formatters';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        position: 'relative',
    },
    content: {
        padding: 0
    },
    inner: {
      [theme.breakpoints.up('md')]: {
        minWidth: 700,
      },
    },
    nameCell: {
        display: 'flex',
        alignItems: 'center'
    },
    avatar: {
        height: 42,
        width: 42,
        marginRight: theme.spacing(1)
    },
    actions: {
        padding: theme.spacing(1),
        justifyContent: 'flex-end'
    },
}));

const Results = (props: {
    className?: string,
    roomParties: RoomParty[],
    paginatorInfo?: PaginatiorInfo,
    setPage?: (page: number) => void,
    rowsPerPage?: number,
    setRowsPerPage?: (rowsPerPage: number) => void,
    selectedRoomParty?: RoomParty,
    setSelectedRoomParty?: (party: RoomParty) => void,
    hideHeader?: boolean,
    isAdmin?: boolean,
    canEdit?: boolean,
    groupRef?: string,
}) => {
    const {className, rowsPerPage, setPage, setRowsPerPage, paginatorInfo, selectedRoomParty, setSelectedRoomParty, roomParties, hideHeader, isAdmin, canEdit, groupRef, ...rest} = props;
    const classes = useStyles();
    const {history} = useRouter();

    const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => {
        if (setPage) setPage(page + 1);
    };

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
        if (setRowsPerPage) setRowsPerPage(Number(event.target.value));
    };

    const getOccupantNames = (roomParty: RoomParty) => {
        return roomParty.members!.map(member => member.groupMember!.first_name + ' ' + member.groupMember!.last_name).join(', ');
    };


    return (
        <div
            {...rest}
            className={clsx(classes.root, className)}
        >
            <Card>
                {!hideHeader && (
                    <React.Fragment>
                        <CardHeader
                            title={'Room Parties'}
                        />
                        <Divider/>
                    </React.Fragment>
                )}
                <CardContent className={classes.content}>
                    <PerfectScrollbar>
                        <div className={classes.inner}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        {isAdmin && (<TableCell style={{width: 100}}>Id</TableCell>)}
                                        <TableCell>Group</TableCell>
                                        <TableCell>Occupants</TableCell>
                                        <TableCell style={{width: 130}}>Check In</TableCell>
                                        <TableCell style={{width: 130}}>Check Out</TableCell>
                                        <TableCell style={{width: 190}}>Date Booked</TableCell>
                                        <TableCell style={{width: 100}}># Occupants</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {roomParties.map(party => {
                                        return (
                                            <TableRow
                                                hover
                                                key={party.id}
                                                selected={selectedRoomParty === party}
                                                onClick={() => setSelectedRoomParty ? setSelectedRoomParty(party) :
                                                    isAdmin ?
                                                        history.push('/room_party/' + party.id) :
                                                        history.push('/mygroups/room_party/' + btoa(JSON.stringify({
                                                            id: party.id,
                                                            groupRef: party.booking!.group!.booking_form_url
                                                        })))
                                                }
                                            >
                                                {isAdmin && (<TableCell>{party.id}</TableCell>)}
                                                <TableCell>{party.booking && party.booking.group && party.booking.group.name}</TableCell>
                                                <TableCell>{getOccupantNames(party)}</TableCell>
                                                <TableCell>{formatDate(party.start_date)}</TableCell>
                                                <TableCell>{formatDate(party.end_date)}</TableCell>
                                                <TableCell>{party.booking && formatDate(party.booking.created_at)}</TableCell>
                                                <TableCell>{party.members && party.members.length}</TableCell>
                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </div>
                    </PerfectScrollbar>
                </CardContent>
                {paginatorInfo && rowsPerPage && (
                    <CardActions className={classes.actions}>
                        <TablePagination
                            component="div"
                            count={paginatorInfo.total}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                            page={paginatorInfo.currentPage - 1}
                            rowsPerPage={rowsPerPage}
                            rowsPerPageOptions={[25, 50, 100]}
                        />
                    </CardActions>
                )}
            </Card>
            <TableEditBar selected={[]}/>
        </div>
    );
};

export default Results;
